import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import _ from "lodash";
import ImageView from "../ImageView/ImageView";
import { getImageUrl } from "Common/utils/ImageDomain";
import Button from "../ButtonComponent/Button";
import ImageData from "../customImage/ImageSegment";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import CustomInput from "../InputFields/CustomInput";
import { showNotification } from "Common/utils/Notification";

const VideoSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  segmentId,
  segmentType,
  toggleVisiblity,
  versionData,
}) => {
  const [imageUrl, setImageUrl] = useState(data?.video_url);
  const [headerText, setHeaderText] = useState(data?.header_text);
  const [index, setIndex] = useState<any>(undefined);
  const [backgroundImage, setBackgroundImage] = useState<any>(
    data?.background_image ? data?.background_image : ""
  );
  const [backgroundImageId, setBackgroundImageId] = useState<any>("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>("");
  const [eventData, setEventData] = useState<any>();
  const [showVideo, setShowVideo] = useState(false);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [subHeaderText, setSubHeaderText] = useState(data?.subheader_text);
  const [description, setDescription] = useState(data?.bottom_description);
  const [errors, setErrors] = useState<any>({
    imageUrl: "",
  });

  const toggle = () => setShowVideo(!showVideo);
  useEffect(() => {
    if (eventData && eventData.media_url) {
      if (eventData?.media_type === "video") {
        if (index === "video") {
          setImageUrl(eventData?.media_url);
          setErrors((prev) => ({ ...prev, ["imageUrl"]: "" }));
        }
        if (index === undefined) {
          setBackgroundImage(eventData.media_url);
          setBackgroundImageId(eventData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (index === "background") {
          setMobileBackground(eventData.media_url);
          setMobileBackgroundId(eventData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be video", "error");
      }
    }
  }, [eventData, index]);

  const handleSave = async (pageId, id) => {
    console.log(pageId, id);
    const newErrors = {
      imageUrl: imageUrl.trim() === "" ? "Please enter an video URL." : "",
    };

    setErrors(newErrors);

    if (!newErrors.imageUrl) {
      const payload = {
        segment_type: "video_segments",
        video_url: imageUrl,
        header_text: headerText,
        subheader_text: subHeaderText,
        bottom_description: description,
        

        background_image: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImage,
        background_image_id: (backgroundImage === null || backgroundImage == undefined) ? "" : backgroundImageId,
        mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
        mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Video added successfully!", "success");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the video. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          <div className="flex my-4">
            {imageUrl ? (
              <div className="flex items-center">
                <div className="relative w-40 h-40 ">
                  <iframe
                    src={getImageUrl(imageUrl)}
                    className="rounded "
                    style={{
                      objectFit: "contain",
                      width: "100%",
                      height: "100%",
                      cursor: "pointer",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: "0px",
                      right: "6px",
                      fontSize: "22px",
                      color: "grey",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setImageUrl(null);

                      setEventData(null);
                    }}
                  >
                    ×
                  </span>
                </div>
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndex("video");
                      setEventData(null);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndex("video");
                  setEventData(null);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add VideoUrl
              </button>
            )}
          </div>
          {errors.imageUrl && <p className="text-red-500">{errors.imageUrl}</p>}
        </div>
        <div>
          <div className="flex my-4">
            {backgroundImage ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={backgroundImage}
                  setImageData={setEventData}
                  setImageLink={setBackgroundImage}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndex(undefined);
                      setEventData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndex(undefined);
                  setEventData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setEventData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggle();
                      setIndex("background");
                      setEventData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggle();
                  setIndex("background");
                  setEventData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>

        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Header Text"
            value={headerText}
            onChange={(e) => {
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData?.header_text ? true : false}
            versionedValue={versionData?.header_text}
          />
        </div>

        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Sub Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Sub Header Text"
            value={subHeaderText}
            onChange={(e) => {
              setSubHeaderText(e.target.value);
            }}
            isVersioned={versionData?.subheader_text ? true : false}
            versionedValue={versionData?.subheader_text}
          />
        </div>

        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Description"
            name="imageAlt"
            type="text"
            placeholder="Enter description"
            value={description}
            onChange={(e) => {
              setDescription(e.target.value);
            }}
            isVersioned={versionData?.bottom_description ? true : false}
            versionedValue={versionData?.bottom_description}
          />
        </div>

        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showVideo}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Video"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showVideo}
            setEventData={setEventData}
            togleImage={toggle}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default VideoSegment;
